export default {
    customers: [],
    activeCustomer: {},
    manageCustomerDialog: false,
    deleteCustomerDialog: false
}
